  <div class="informaton-container">
    <div class="row text-center">
      <div class="col">
        <div class="modal-icon-box-center mb-2">
          <img src='assets/img/images/faq-icon.svg' alt='FAQ icon'/>
        </div>
        <div class="faq-title">Frequently Asked Questions (FAQ)</div>   
        <ng-container *ngIf="showCompany==='all'">
          <div class="logged-email-text col-526570 mt-2">
            {{ "Applies to Massachusetts policies only." | translate }}
          </div>
        </ng-container>     
      </div>
    </div>

    <hr class="hr-profile mt-4 mb-0"/>
  
    <div class="padding-vertical pv16 faq-border-bottom">
      <a [routerLink]="['policy']" mdbRipple>
        <div class="faq-item">
          <div class="faq-item-title">Policy questions</div>
            <div class="faq-arrow-block">           
              <img src="assets/img/images/icon-strong-arrow-right.svg" alt="strong right arrow" />
            </div>
        </div>
      </a>
    </div>
  
    <div class="padding-vertical pv16 faq-border-bottom">
      <a [routerLink]="['billing']" mdbRipple>
        <div class="faq-item">
          <div class="faq-item-title">Billing questions</div>
            <div class="faq-arrow-block">
              <img src="assets/img/images/icon-strong-arrow-right.svg" alt="strong right arrow" />
            </div>
        </div>
      </a>
    </div>
  
    <div class="padding-vertical pv16 faq-border-bottom">
      <a [routerLink]="['claims']" mdbRipple>
        <div class="faq-item">
          <div class="faq-item-title">Claims questions</div>
            <div class="faq-arrow-block">
              <img src="assets/img/images/icon-strong-arrow-right.svg" alt="strong right arrow" />
            </div>
        </div>
      </a>
    </div>
  
    <div class="padding-vertical pv16 faq-border-bottom">
      <a [routerLink]="['other-questions']" mdbRipple>
        <div class="faq-item">
          <div class="faq-item-title">Other questions</div>
            <div class="faq-arrow-block">
              <img src="assets/img/images/icon-strong-arrow-right.svg" alt="strong right arrow" />
            </div>
        </div>
      </a>
    </div>

    <ng-container *ngIf="showCompany==='all'">
      <div class="logged-email-text text-center top-space col-526570">
        {{ "If you have questions about policies in other states please" | translate }} 
          <a routerLink="/contact" class="see-dec dm-sans-medium">{{ "call us." | translate }}</a>
      </div>
    </ng-container> 
 </div>
  